<template>
<v-container fluid >
    
    <v-card elevation="11" class="ma-3 pa-3 primary">
    <v-row>
    <v-col cols="6">
      <v-card class="secondary ma-5 pa-5 " elevation="11">
        <v-row class="justify-center">
      <v-chip large v-for="(month) in months" :key="month.id" @click="calculateBenefits(month)" class="ma-5 pa-5 quaterny text-h5 primary--text font-weight-black">{{month.month}}
      </v-chip>
      </v-row>
      </v-card>
    </v-col>  
    <v-col cols="6">
        <v-row class="justify-center">
          <h1 class="textTitle--text font-weight-black">{{ $t('views.beneficios.ScreenTitle') }}</h1><h1 class="ml-3 textTitle--text font-weight-black">{{selectedMonth}}</h1>
        </v-row>
        
        <v-row class="justify-center ma-5 pa-3 secondary align-center">
          <h2 class="textMenu--text font-weight-black">{{ $t('views.beneficios.totalBuy') }}</h2>
          <v-chip label class="pa-2 ma-2 quaterny"><h1 class="primary--text text-center">{{totalCompras}}</h1></v-chip>
          
        </v-row>
        <v-row class="justify-center ma-5 pa-3 secondary align-center">
          <h2 class="textMenu--text font-weight-black">{{ $t('views.beneficios.totalSell') }}</h2>
          <v-chip label class="pa-2 ma-2 quaterny"><h1 class="primary--text text-center">{{totalVentas}}</h1></v-chip>
          
        </v-row>
        <v-row class="justify-center ma-5 pa-3 secondary align-center">
          <h2 class="textMenu--text font-weight-black">{{ $t('views.beneficios.benefits') }}</h2>
           <v-chip v-if="benefit>=0" label class="pa-2 ma-2 success"><h1 class="primary--text text-center">{{benefit}}</h1></v-chip>
           <v-chip v-else label class="pa-2 ma-2 error"><h1 class="primary--text text-center">{{benefit}}</h1></v-chip>
        </v-row>

        
        
    </v-col>
    </v-row> 
    <v-row class="justify-center ma-10 pa-10 secondary align-center">
         <salesByProd/>
          
        </v-row>   
      
    </v-card>
    
    
</v-container>
</template>

<script>
import salesByProd from '@/components/salesByProd'
          
export default {
  components:{salesByProd},
    data () {
        return {
            selectedMonth:'',
            totalCompras:0,
            totalVentas:0,
            benefit:0,
            search:"",
            dialogDelete:false,
            dialogModif:false,
            returnprod:0,

            buyactive:{},

        }

    },
    computed:{
      months(){
       var months=[{id:0,month:this.$i18n.t('months.1')},
                    {id:1,month:this.$i18n.t('months.2')},
                    {id:2,month:this.$i18n.t('months.3')},
                    {id:3,month:this.$i18n.t('months.4')},
                    {id:4,month:this.$i18n.t('months.5')},
                    {id:5,month:this.$i18n.t('months.6')},
                    {id:6,month:this.$i18n.t('months.7')},
                    {id:7,month:this.$i18n.t('months.8')},
                    {id:8,month:this.$i18n.t('months.9')},
                    {id:9,month:this.$i18n.t('months.10')},
                    {id:10,month:this.$i18n.t('months.11')},
                    {id:11,month:this.$i18n.t('months.12')},
                    {id:12,month:this.$i18n.t('months.13')}]
              return months
      },
      sales(){
        return this.$store.state.sales
      },
      compras(){
        return this.$store.state.bills
      }

    },
    methods:{
        calculateBenefits(month){
          this.selectedMonth=month.month;
          
          //var month = this.selectedMonth.toLowerCase()
          this.totalCompras = 0;
          this.totalVentas = 0;
          this.benefit = 0;
          var monthop;

          if(this.sales.length){
            for(var i=0;i<this.sales.length;i++){
              if(month.id!=12){
              monthop=new Date(this.sales[i].fecha).getMonth()
              //console.log(monthop)
              //console.log(month)
              if(month.id==monthop){
                this.totalVentas+=this.sales[i].total
                }}else{
                  this.totalVentas+=this.sales[i].total
                }
            }
          }

          monthop=12;

          if(this.compras.length){
            for(var u=0;u<this.compras.length;u++){
              if(month.id!=12){
              monthop=new Date(this.compras[u].date).getMonth()
              if(month.id==monthop){
                this.totalCompras+=this.compras[u].total
                }}else{
                  this.totalCompras+=this.compras[u].total
                }
            }
          }

          this.benefit=this.totalVentas-this.totalCompras
        }
      

    }
}
</script>